import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { reportError } from 'utils/error'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'
import { sendToApi } from 'api/client'
import * as Actions from 'redux/actions'
import { useDispatch } from 'react-redux'

export type Options = Omit<UseMutationOptions<void>, 'mutationKey' | 'mutationFn'>

export const useOnboard = (options?: Options) => {
  const dispatch = useDispatch()
  return useMutation<void>(
    ['userAppPreferences'],
    async (variables) => {
      const response = await sendToApi('/onboard', {
        method: 'PUT',
      })

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        reportError('Failed to onboard user', {
          metaData: {
            response: response.data,
          },
        })
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }

      dispatch(
        Actions.authMerge({
          auth: {
            onboarded: true,
          },
        }),
      )
    },
    {
      ...options,
    },
  )
}
